import { render, staticRenderFns } from "./legal_lawyer_index.vue?vue&type=template&id=cc654718&scoped=true"
import script from "./legal_lawyer_index.vue?vue&type=script&lang=js"
export * from "./legal_lawyer_index.vue?vue&type=script&lang=js"
import style0 from "./legal_lawyer_index.vue?vue&type=style&index=0&id=cc654718&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc654718",
  null
  
)

export default component.exports